import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const WHATSAPP_URL =
  "https://wa.me/+2348030914767?text=" +
  encodeURIComponent("Hi Emmanuel, I'd like to get in touch!");

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-2">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            className="bg-gray-900 border border-gray-700 text-white text-sm rounded-xl px-4 py-3 shadow-xl max-w-xs"
          >
            <p className="font-medium mb-0.5">Chat with me on WhatsApp</p>
            <p className="text-gray-400 text-xs">Typically replies instantly</p>
          </motion.div>
        )}
      </AnimatePresence>

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-black/30 cursor-pointer"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
        </motion.div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
